// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"4701":"svg-icons","8177":"remix-icons","9222":"blueprint-icons"}[chunkId] || chunkId) + "." + {"1410":"ca9f8356","2091":"bb8f47e4","2359":"cef72e0f","3213":"f9cf3c48","4701":"9c07b2ac","5232":"6b57de65","8177":"ee68420e","9222":"7f0990c6"}[chunkId] + ".chunk.js";
};